import { render, staticRenderFns } from "./ArtistPersonalInfoTab.vue?vue&type=template&id=758ee253&scoped=true"
import script from "./ArtistPersonalInfoTab.vue?vue&type=script&lang=js"
export * from "./ArtistPersonalInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758ee253",
  null
  
)

export default component.exports